import { render, staticRenderFns } from "./TokenManagementTransactionsTable.vue?vue&type=template&id=4f5f5b09&scoped=true&lang=pug"
import script from "./TokenManagementTransactionsTable.vue?vue&type=script&lang=ts"
export * from "./TokenManagementTransactionsTable.vue?vue&type=script&lang=ts"
import style0 from "./TokenManagementTransactionsTable.vue?vue&type=style&index=0&id=4f5f5b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f5b09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
